import React from "react";
import ResetConfirmation from "./ResetConfirmation";

const ResetConfirmationWithQuery = props => {
  return <ResetConfirmation {...props} />;
};

export default ResetConfirmationWithQuery;
